import { combineReducers } from 'redux';

import auditLog from './auditLog';
import auth from './auth/';
import customers from './customers';
import documents from './documents';
import organizationalStructure from './organizationalStructure';
import users from './users';
import stats from './stats';
import notifications from './notifications';
import signs from './signs';

const appReducer = combineReducers({
    auditLog,
    auth,
    customers,
    documents,
    notifications,
    organizationalStructure,
    signs,
    stats,
    users
});

const rootReducer = (state, action) => {

    // Reset redux state to default when sign-out
    if (action.type === 'SIGNOUT') {
        state = undefined;
    }

    return appReducer(state, action)
};

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js